import React from 'react';
import { BackgroundWrapperProps } from 'components/BackgroundWrapper/BackgroundWrapper.types';
import styles from './BackgroundWrapper.module.css';

const BackgroundWrapper = ({ children }: BackgroundWrapperProps) => {
  return <div className={styles.wrapper}>{children}</div>;
};

export default BackgroundWrapper;
